import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { setToken } from "../utils/auth";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const credential = await signInWithEmailAndPassword(auth, email, password);
      const idToken = await credential.user.getIdToken();
      setToken(idToken);
      // signal other components (Header) to update immediately
      try { window.dispatchEvent(new Event('authChanged')); } catch(e){}
      // navigate back to original protected page or to root
      const dest = location.state && location.state.from ? location.state.from.pathname : "/";
      navigate(dest, { replace: true });
    } catch (err) {
      alert("Login error: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100">
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded-xl shadow-lg w-full max-w-md border border-gray-200">
        <h2 className="text-2xl font-bold mb-4 text-center text-blue-700">Login</h2>
        <label className="block mb-2">
          <span className="text-sm text-gray-700">Email</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 block w-full border rounded px-3 py-2 focus:outline-blue-400" />
        </label>
        <label className="block mb-4">
          <span className="text-sm text-gray-700">Password</span>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 block w-full border rounded px-3 py-2 focus:outline-blue-400" />
        </label>
        <button className="w-full bg-blue-600 text-white py-2 rounded font-semibold hover:bg-blue-700" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
}

export default Login;
